<div *ngFor="let table of arrTable" class="elementinnerholder" [attr.data-docid]="table.docid">
    <div class="content" [innerHTML]="table.boxtitle | safeHtml"></div>

    <div class="clear-all"> </div>
</div>
